import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { fetchReviewChartAggregations } from 'services/verticalsApi'
import { REVIEW_ACTIVITY_TYPE } from '../Reviews/reviewQueryUtils'

interface HostReviewChartParams {
  entityId?: string
  activityIndex: string
}

export const useHostReviewChartQuery = ({ entityId, activityIndex }: HostReviewChartParams) => {
  const { data, isLoading } = useQuery({
    queryKey: ['str-host-review-chart', entityId, activityIndex],
    queryFn: () => fetchReviewChartAggregations(entityId!, [], activityIndex, REVIEW_ACTIVITY_TYPE, '1y'),
    enabled: !!entityId && !!activityIndex,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  })

  const reviewChartData = useMemo(() => {
    if (!data?.chartBuckets) return []
    return data.chartBuckets.map(bucket => ({ year: bucket.month as string, reviews: bucket.totalReviews }))
  }, [data?.chartBuckets])

  return {
    reviewChartData,
    totalReviews: data?.total ?? 0,
    isLoading,
  }
}
